import styled from 'styled-components'

export const StyledContentContainer = styled.div`
  max-width: 575px;
  padding: 20px;

  .deposit-modal-title {
    color: ${({ theme }) => theme.colors.textContent};
    font-weight: 500;
    font-size: 21px;
    @media screen and (max-width: 640px) {
      font-size: 17px;
    }
  }
  .description {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.textTertiary};
    @media screen and (max-width: 640px) {
      font-size: 13px;
    }
    p {
      margin-top: 10px;
    }
  }
`

export const StyledDepositArea = styled.section`
  position: relative;
  margin-top: 27px;
  .balance {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 17px;
    .label,
    .value {
      color: #8982be;
    }
  }
  .input-title {
    font-size: 17px;
    color: #8982be;
    margin-top: 10px;
    @media screen and (max-width: 640px) {
      font-size: 13px;
    }
  }
  .deposit-input-field {
    position: relative;
  }
  .deposit-numbers {
    background: #f4f5f6;
    border-radius: 16px;
    width: 100%;
    padding: 15px 20px;
    border: none;
    outline: none;
    margin-top: 12px;
    color: #5f55a9;
    font-weight: 500;
    font-size: 21px;
    padding-right: 100px;
    &::-webkit-input-placeholder {
      color: ${({ theme }) => theme.colors.textPlaceholder};
    }
  }
  .all-btn {
    position: absolute;
    right: 14px;
    top: 25px;
    background: rgba(95, 77, 188, 0.1);
    border-radius: 8px;
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 500;
    font-size: 15px;
    cursor: pointer;
    padding: 8px 12px;
    border: none;
    outline: none;
  }
`

export const StyledEstimateArea = styled.section`
  margin-top: 22px;
  .rate-area,
  .gain-area {
    display: flex;
    justify-content: space-between;
    .rate-text,
    .gain-text,
    .rate-value {
      font-size: 17px;
      color: #8982be;
    }
  }
  .rate-area {
    border-bottom: 1px solid ${({ theme }) => theme.colors.borderDefault};
    padding-bottom: 25px;
  }
  .gain-area {
    margin-top: 20px;
  }
  .gain-value {
    color: #5f55a9;
    font-weight: 500;
    font-size: 21px;
  }
  .estimate-value {
    font-size: 17px;
    display: flex;
    justify-content: flex-end;
    color: #8982be;
  }
`

export const StyledDepositBtn = styled.section`
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  .confirm-deposit-btn {
    font-weight: 500;
    font-size: 17px;
    color: #ffffff;
    background: ${({ theme }) => theme.colors.primary};
    padding: 10px 46px;
    border-radius: 628px;
    margin-left: 12px;
    cursor: pointer;
    outline: none;
    border: none;
    @media screen and (max-width: 640px) {
      padding: 10px 24px;
    }
  }
`
